var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"c87210ac82f5a6d0519c5543d96661d0cf1190bd"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["payex-web@flywire"]={id:"c87210ac82f5a6d0519c5543d96661d0cf1190bd"};
      